import React from 'react';
import { isObject, omit } from 'lodash';
import classnames from 'classnames';
import { WrappedFieldProps } from 'redux-form';
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import { Checkbox, FormControlLabel, FormControl, Theme } from '@material-ui/core';

import { Typography } from './Typography';

const useStyles = (theme: Theme) =>
  createStyles({
    labelRoot: {
      marginLeft: 0,
    },
    root: {
      padding: 0,
      marginRight: 2 * theme.spacing.unit,
    },
    normal: {
      fontWeight: 500,
    },
    inline: {
      display: 'inline-block',
      width: 'auto',
      whiteSpace: 'nowrap',
      paddingRight: 50,
    },
  });

enum labelPositionEnum {
  'left',
  'right',
}
interface NewFormCheckboxProps extends WrappedFieldProps, WithStyles<typeof useStyles> {
  inline?: boolean;
  label: string;
  labelPosition?: labelPositionEnum;
  disabled?: boolean;
  labelStyle: any;
  labelClass: string;
  locked?: boolean;
  custom: any;
  color?: 'primary' | 'secondary' | 'default';
}

const NewFormCheckbox: React.FC<NewFormCheckboxProps> = ({
  inline,
  input,
  label,
  labelPosition,
  disabled,
  labelStyle,
  labelClass,
  classes,
  color,
  ...custom
}) => {
  const checked = isObject(input.value) ? false : input.value || false;

  const onCheck = (_: any, value: boolean) => {
    const { onChange } = input;
    onChange(value);
  };

  return (
    <FormControl fullWidth>
      <FormControlLabel
        classes={{ root: classes.labelRoot }}
        control={
          <Checkbox
            checked={Boolean(checked)}
            disabled={disabled}
            className={classnames(classes.root, inline ? classes.inline : classes.normal)}
            color={color || 'primary'}
            {...input}
            onChange={onCheck}
            // https://github.com/react-dnd/react-dnd/issues/701
            onDrop={(e) => e.preventDefault()}
            {...omit(custom, 'meta')}
          />
        }
        label={
          <Typography
            className={labelClass}
            style={labelStyle}
            variant="bW500F17"
            color={disabled ? 'inherit' : 'supportMidnight'}
          >
            {label}
          </Typography>
        }
        labelPlacement={labelPosition === labelPositionEnum.left ? 'start' : 'end'}
      />
    </FormControl>
  );
};

export default withStyles(useStyles)(NewFormCheckbox);
